var Globals = {
  BASE_URL: "https://codex.inkless.digital",
};

export default Globals
// Updating